






































import Vue from 'vue';
import ButtonComponent from './button.component.vue';
import InputComponent from '../components/fields/input.component.vue';
export default Vue.extend({
    name: 'map-marker-details',
    components: {
        ButtonComponent,
        InputComponent
    },
    data: function() {
        return {
            locationName: '',
            showInput: false
        };
    },
    props: {
        header: String,
        body: String,
        markerLatLngData: Object,
        buttonLeft: String,
        buttonRight: String
    },
    methods: {
        onSaveMarkerClicked() {
            this.$emit('onSaveMarkerClicked', this.markerLatLngData, this.locationName);
            this.locationName = '';
        },
        onCloseModalClicked() {
            this.$emit('onCloseModalClicked');
        }
    },
});
